import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  getDoc
} from "firebase/firestore";
import { SistemaPuntuacion } from "../models/types";

const sistemasCollection = collection(db, "sistemasPuntuacion");

export const SistemaPuntuacionServiceFirestore = {
  async create(sistema: Omit<SistemaPuntuacion, "id">) {
    const docRef = await addDoc(sistemasCollection, sistema);
    return { ...sistema, id: docRef.id };
  },

  async getAll(): Promise<SistemaPuntuacion[]> {
    const snapshot = await getDocs(sistemasCollection);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as SistemaPuntuacion));
  },

  async getById(id: string): Promise<SistemaPuntuacion | null> {
    const docRef = doc(db, "sistemasPuntuacion", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as SistemaPuntuacion;
    }
    return null;
  },

  async update(id: string, sistemaData: Partial<SistemaPuntuacion>) {
    const docRef = doc(db, "sistemasPuntuacion", id);
    await updateDoc(docRef, sistemaData);
  },

  async delete(id: string) {
    const docRef = doc(db, "sistemasPuntuacion", id);
    await deleteDoc(docRef);
  }
};
